import { render } from "./messages.vue?vue&type=template&id=be35ddc6&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import "./messages.vue?vue&type=style&index=0&id=be35ddc6&scoped=true&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/messages-app V2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be35ddc6"]])

export default __exports__